import React from 'react'
import clsx from 'clsx'
import { NotificationTypes, useNotifications } from '../hooks/useNotifications.jsx'

const typeToLabel = {
  [NotificationTypes.INFO]: 'Information',
  [NotificationTypes.SUCCESS]: 'Success',
  [NotificationTypes.WARNING]: 'Warning',
  [NotificationTypes.ERROR]: 'Error',
}

const NotificationCenter = () => {
  const { notifications, dismiss } = useNotifications()

  if (!notifications.length) {
    return null
  }

  return (
    <div className="notification-center" role="region" aria-live="polite">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={clsx('notification', `notification--${notification.type}`)}
          role="status"
        >
          <div className="notification__body">
            <div className="notification__icon" aria-hidden="true">
              {notification.type === NotificationTypes.SUCCESS && '✓'}
              {notification.type === NotificationTypes.ERROR && '⚠'}
              {notification.type === NotificationTypes.WARNING && '⚠'}
              {notification.type === NotificationTypes.INFO && 'ℹ'}
            </div>
            <div className="notification__content">
              <strong className="notification__title">
                {notification.title || typeToLabel[notification.type] || 'Notice'}
              </strong>
              {notification.message ? (
                <p className="notification__message">{notification.message}</p>
              ) : null}
            </div>
          </div>
          <button
            type="button"
            className="notification__dismiss"
            onClick={() => dismiss(notification.id)}
            aria-label="Dismiss notification"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  )
}

export default NotificationCenter
